import * as Yup from "yup";

export const materialItemFilterValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
  material_item_id: Yup.number().nullable().required(),
});

export const packagingFilterValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
  packaging_id: Yup.number().nullable().required(),
});

export const multiplePackagingFilterValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
  order_id: Yup.number().nullable().required(),
  material_id: Yup.number().nullable().required(),
});

export const orderFilterValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
  order_id: Yup.number().nullable().required(),
});

export const multipleOrderFilterValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
});

export const reelLabValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
  quality_result_id: Yup.number().nullable().required(),
});

export const multipleQualityValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
  order_id: Yup.number().nullable().required(),
});

export const multipleItemFilterValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
  order_id: Yup.number().nullable().required(),
  material_id: Yup.number().nullable().required(),
});

export const multiOrdersPackagingFilterValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),

  order_ids: Yup.array().of(Yup.number().required()).min(1).required(),

  packaging_ids: Yup.array().of(Yup.number().required()).optional(),
});

export const multiCompanyPackagingValidation = Yup.object({
  company_id: Yup.number().integer().positive().required(),
  packaging_ids: Yup.array()
    .of(Yup.number().integer().positive().required())
    .required(),
});

export const driggingRiggValidation = Yup.object({
  id: Yup.number().nullable().required("Report id is required"), // ⚡️
  drigging_rigg_field: Yup.string().required("Field is required"),
  drigging_rigg_datetime_start: Yup.string().required("Start date is required"),
  drigging_rigg_datetime_end: Yup.string()
    .required("End date is required")
    .test(
      "is-after-start",
      "End date must be after start date",
      function validateEndDate(value) {
        const { drigging_rigg_datetime_start } = this.parent;
        return (
          !drigging_rigg_datetime_start ||
          !value ||
          new Date(value) > new Date(drigging_rigg_datetime_start)
        );
      }
    ),

  drigging_rigg_n_points: Yup.number()
    .required("Number of points is required")
    .min(1, "Must be at least 1"),
});

export const stockValidation = Yup.object({
  company_id: Yup.number()
    .typeError("Company ID must be a number")
    .required("Company ID is required"),
});

export const reelLabResultMultipleValidation = Yup.object({
  id: Yup.number().nullable().required(),
  // Company is optional: only Option A (Company → Product Card) uses it, while
  // Option B (Material) and Option C (date range only) leave it empty.
  company_id: Yup.number().nullable().typeError("Company ID must be a number"),
  material_id: Yup.number().nullable(),
  product_card_list_id: Yup.array()
    .of(Yup.number().typeError("Product Card ID must be a number"))
    .when("company_id", {
      is: (company_id: number) => company_id != null,
      then: (schema) =>
        schema.min(
          1,
          "At least one product card is required when company is selected"
        ),
      otherwise: (schema) => schema,
    }),
  quality_result_material_item_timestamp_start: Yup.string()
    .nullable()
    .required("Start date is required"),
  quality_result_material_item_timestamp_end: Yup.string()
    .nullable()
    .required("End date is required")
    .test(
      "is-after-start",
      "End date must be after start date",
      function validateEndDate(value) {
        const { quality_result_material_item_timestamp_start } = this.parent;
        return (
          !quality_result_material_item_timestamp_start ||
          !value ||
          new Date(value) >
            new Date(quality_result_material_item_timestamp_start)
        );
      }
    ),
});
